var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"head-container"},[_c('the-tools-logo',{staticClass:"head-container__tools-logo"}),_c('div',{staticClass:"head-container__title"},[_vm._v(" Ylands Dashboard ")]),_c('div',{staticClass:"head-container__description"},[_vm._v(" Use the following shortcuts to manage your creations ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }